import React from 'react';
import { useLocalization } from 'src/utils/useLocalization';

import './header.scss';

const Header: React.FC = () => {
    const { statusSummary } = useLocalization();

    return (
        <div className='status-summary-header'>
            <div className='status-summary-header_title'>
                {statusSummary.LABEL_STATUS_SUMMARY}
            </div>
            <div className='status-summary-header_info'>
                {statusSummary.LABEL_STATUS_SUMMARY_INFO}
            </div>
        </div>
    );
};

export default Header;
